import { defaultState, type WizardState } from './schema';

export interface StoreChange {
  /** Id del atributo que cambió (o 'step' al navegar, '*' en reset). */
  key: string;
  state: WizardState;
}

type Listener = (change: StoreChange) => void;

/**
 * Store observable simple para el estado del wizard. Mantiene los valores por
 * atributo y el paso actual; notifica a los suscriptores en cada cambio.
 */
export class ConfigStore {
  private state: WizardState;
  private listeners = new Set<Listener>();
  private _step = 0;

  constructor(initial?: WizardState) {
    this.state = initial ?? defaultState();
  }

  getState(): WizardState {
    return this.state;
  }

  get<T = string | number | string[]>(key: string): T {
    return this.state[key] as T;
  }

  /** Asigna un valor y notifica si cambió. */
  set(key: string, value: string | number | string[]): void {
    if (this.state[key] === value) return;
    this.state[key] = value;
    this.emit({ key, state: this.state });
  }

  get step(): number {
    return this._step;
  }

  setStep(index: number): void {
    if (index === this._step) return;
    this._step = index;
    this.emit({ key: 'step', state: this.state });
  }

  subscribe(fn: Listener): () => void {
    this.listeners.add(fn);
    return () => this.listeners.delete(fn);
  }

  private emit(change: StoreChange): void {
    for (const fn of this.listeners) fn(change);
  }
}
